import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';
import { IFilterCondition } from '@pdqdev/pdq-shared/dist/interfaces';
import { DropdownOption } from '../../../../../../storybook/components/dropdown/dropdown.component';

@Pipe({
  name: 'IFilterUniqueOptions',
  standalone: false,
})
export class IFilterUniqueOptions implements PipeTransform {
  transform(
    conditions: IFilterCondition[],
    choosedConditions: { conditionName: string; conditionValue: string }[],
    currentOptionName: string,
  ): DropdownOption[] {
    if (!conditions) {
      return [];
    }

    const filteredConditions = conditions.filter((condition) => {
      const nonChoosedCondition = !choosedConditions.some(
        (choosedOption) => choosedOption.conditionName === condition.name,
      );
      const isCurrentCondition = condition.name === currentOptionName;
      return nonChoosedCondition || isCurrentCondition;
    });

    return filteredConditions.map((condition) => new IFilterOptionPipe().transform(condition));
  }
}

@Pipe({
  name: 'IFilterOptionPipe',
  standalone: false,
})
export class IFilterOptionPipe implements PipeTransform {
  transform(condition: IFilterCondition): DropdownOption {
    if (!condition) {
      return null;
    }
    return {
      label: condition.label,
      value: condition.name,
    };
  }
}
